import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'ReferAndEarnIcon',
  viewBox: '0 0 24 24',
  defaultProps: {
    boxSize: 6,
  },
  path: (
    <path
      d="M10.375 12a7.125 7.125 0 0 1 7.125 7.125v.003l-.001.12a.75.75 0 0 1-.363.629 13.07 13.07 0 0 1-6.761 1.873c-2.471 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122A7.125 7.125 0 0 1 10.375 12m0 1.5c-3 0-5.45 2.348-5.616 5.306a11.6 11.6 0 0 0 5.616 1.444c2.038 0 3.951-.524 5.615-1.444a5.624 5.624 0 0 0-5.615-5.306m7.344-5.655a.75.75 0 0 1 1.06 1.06l-.97.97h1.315a2.875 2.875 0 0 1 2.875 2.875.75.75 0 0 1-1.5 0c0-.76-.616-1.375-1.375-1.375H17.81l.97.97a.75.75 0 0 1-1.061 1.06l-2.25-2.25a.75.75 0 0 1 0-1.06zM10.375 2.25a4.125 4.125 0 1 1 0 8.25 4.125 4.125 0 0 1 0-8.25m0 1.5a2.625 2.625 0 1 0 0 5.25 2.625 2.625 0 0 0 0-5.25"
      fill="currentColor"
    />
  ),
});
